import { Injectable } from '@angular/core';
import { Ranking } from './ranking';
import { MocksService } from '../app-commons/mocks/mocks.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RankingsService {

  rankings: Ranking[] = [];

  constructor(
    private mocks: MocksService
  ) {
  }

  requestRankings(): Observable<Ranking[]> {
    return this.mocks.get('rankings/mc-rookie2024.json').pipe(
      map(response => JSON.parse(response))
    );
  }
}
